/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Review5_QuoteInputs */

const es_landing_review5_quote = /** @type {(inputs: Landing_Review5_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencia increíble: atardecer, la ciudad iluminada y el paseo en barco… ¡todo de 10! Repetiré seguro.`)
};

const gl_landing_review5_quote = /** @type {(inputs: Landing_Review5_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencia incrible: solpor, a cidade iluminada e o paseo en barco… todo un 10! Repetirei seguro.`)
};

const en_landing_review5_quote = /** @type {(inputs: Landing_Review5_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incredible experience: sunset, the lit-up city and the boat trip — a perfect 10! I will be back.`)
};

/**
* | output |
* | --- |
* | "Incredible experience: sunset, the lit-up city and the boat trip — a perfect 10! I will be back." |
*
* @param {Landing_Review5_QuoteInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_review5_quote = /** @type {((inputs?: Landing_Review5_QuoteInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Review5_QuoteInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_review5_quote(inputs)
	if (locale === "en") return en_landing_review5_quote(inputs)
	return es_landing_review5_quote(inputs)
});